import React from 'react';
import { Route } from 'react-router-dom';
import * as ROUTES from '../constants/routes';

import ChangeImpacts from '../pages/projects/change-impacts/index';
import ChangeImpactNew from '../pages/projects/change-impacts/new';
import ChangeImpactDataImport from '../pages/projects/change-impacts/data-import';
import ChangeImpactShow from '../pages/projects/change-impacts/show';
import ChangeImpactEdit from '../pages/projects/change-impacts/edit';

export const changeImpactRoutes = () => (
  <>
    <Route path={ROUTES.CHANGE_IMPACTS_INDEX} element={<ChangeImpacts />} />
    <Route path={ROUTES.CHANGE_IMPACTS_NEW} element={<ChangeImpactNew />} />
    <Route
      path={ROUTES.CHANGE_IMPACTS_DATA_IMPORT}
      element={<ChangeImpactDataImport />}
    />
    <Route path={ROUTES.CHANGE_IMPACTS_SHOW} element={<ChangeImpactShow />} />
    <Route path={ROUTES.CHANGE_IMPACTS_EDIT} element={<ChangeImpactEdit />} />
  </>
);
